export enum GuaranteeTypeEnum {
	PendingToConsent = 1,
	Consented = 2,
	Declined = 3,
	RequestConfirmed = 4
}

export const guaranteeStatusName = {
	PendingToConsent: 'Pending Admin Approve Guarantor Request',
	Consented: 'Pending Deal Completion',
	Declined: 'Rejected request of Mortgage Deal',
	RequestConfirmed: 'Consent request of Mortgage Deal'
};

export const guaranteeTypeMapper = new Map<GuaranteeTypeEnum, string>();

guaranteeTypeMapper.set(GuaranteeTypeEnum.PendingToConsent, guaranteeStatusName.PendingToConsent);
guaranteeTypeMapper.set(GuaranteeTypeEnum.Consented, guaranteeStatusName.Consented);
guaranteeTypeMapper.set(GuaranteeTypeEnum.Declined, guaranteeStatusName.Declined);
guaranteeTypeMapper.set(GuaranteeTypeEnum.RequestConfirmed, guaranteeStatusName.RequestConfirmed);

export const TYPE_FILTER_GUARANTEE = {
	ALL_GUARANTEE: 0,
	IN_PROGRESS_GUARANTEE: 1,
	DECLINE_OPTION_GUARANTEE: 2,
	CLOSED_OPTION_GUARANTEE: 3
};

// filter guarantee list will use to status of mortgage deal

export const IN_PROGRESS_VALUE_LIST = [1, 2, 3, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

export const DECLINE_VALUE_GUARANTEE = [4, 5, 8];

export const CLOSED_VALUE_GUARANTEE = [5];

export const SUCCESS_ITEM = '#5DA84F';
export const PENDING_ITEM = '#1890FF';

export const REJECT_ITEM = '#FF5059';
